export const getComparableShopifyId = (id: string | number) =>
  String(id).split("/").pop() ?? String(id);

export const toShopifyNumericId = (id: string | number) => {
  const numericId = Number(getComparableShopifyId(id));

  if (!Number.isFinite(numericId)) {
    throw new Error(`Invalid Shopify ID: ${id}`);
  }

  return numericId;
};
